import getCustomTextColorsStylesheet from './get-custom-text-color-stylesheet';
import createCustomTextColorStylesheet from './create-custom-text-color-stylesheet';
import constants from '../../constants';
import getCssVariablesMap from './get-css-variables-map';

const getCssRootVariablesMap = () => {
  let customStylesheet = getCustomTextColorsStylesheet();

  if (!customStylesheet) {
    customStylesheet = createCustomTextColorStylesheet();
  }

  const stylesList = Object.values(customStylesheet.cssRules).reduce((cssRulesString, cssRule) => {
    if (cssRule.selectorText === constants.ROOT_CSS_SELECTOR && cssRule.style) {
      return cssRulesString + cssRule.style.cssText;
    }

    return cssRulesString;
  }, '');

  return getCssVariablesMap(stylesList);
};

export default getCssRootVariablesMap;
